import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);
// 把下面的代码粘贴到路由模块中对应的位置，即可防止路由报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/News/news.vue"),
  },
  {
    path: "/newdetails",
    name: "newdetails",
    component: () => import("../views/Newdetails/Newdetails.vue"),
  },
  {
    path: "/yiqiliebiao",
    name: "yiqiliebiao",
    component: () => import("../views/yiqiliebiao/yiqiliebiao.vue"),
  },
  {
    path: "/instrumentdetails",
    name: "instrumentdetails",
    component: () => import("../views/Instrumentdetails/Instrumentdetails.vue"),
  },
  {
    path: "/evalist",
    name: "evalist",
    component: () => import("../views/evalist/evalist.vue"),
  },
  {
    path: "/policies",
    name: "policies",
    component: () => import("../views/policies/policies.vue"),
  },
  {
    path: "/polie",
    name: "polie",
    component: () => import("../views/policies/polie.vue"),
  },
  {
    path: "/poxiang",
    name: "poxiang",
    component: () => import("../views/policies/poxiang.vue"),
  },
  {
    path: "/assessment",
    name: "assessment",
    component: () => import("../views/assessment/assessment.vue"),
  },
  {
    path: "/asslie",
    name: "asslie",
    component: () => import("../views/assessment/asslie.vue"),
  },
  {
    path: "/assxiang",
    name: "assxiang",
    component: () => import("../views/assessment/assxiang.vue"),
  },
  {
    path: "/customs",
    name: "customs",
    component: () => import("../views/customs/customs.vue"),
  },
  {
    path: "/cuslie",
    name: "cuslie",
    component: () => import("../views/customs/cuslie.vue"),
  },
  {
    path: "/cusxiang",
    name: "cusxiang",
    component: () => import("../views/customs/cusxiang.vue"),
  },
  {
    path: "/noticelie",
    name: "noticelie",
    component: () => import("../views/notice/noticelie.vue"),
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/notice/notice.vue"),
  },
  {
    path: "/pingtai",
    name: "pingtai",
    component: () => import("../views/pingtai/pingtai.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/denglu",
    name: "denglu",
    component: () => import("../views/login/denglu.vue"),
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("../views/Personal/personal.vue"),
  },
  {
    path: "/guanyu",
    name: "guanyu",
    component: () => import("../views/guanyu/guanyu.vue"),
  },
  {
    path: "/banshi",
    name: "banshi",
    component: () => import("../views/banshi/banshi.vue"),
  },
  {
    path: "/sheshi",
    name: "sheshi",
    component: () => import("../views/sheshi/sheshi.vue"),
  },
  {
    path: "/fence",
    name: "fence",
    component: () => import("../views/fence/fence.vue"),
  },
  {
    path: "/evaxiang",
    name: "evaxiang",
    component: () => import("../views/evalist/evaxiang.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
